import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Tide } from '../../_models/tide';
import { TideService } from '../../_services/tide.service';

@Component({
  selector: 'app-tide-detail',
  templateUrl: './tide-detail.component.html',
  styleUrls: ['./tide-detail.component.sass'],
})
export class TideDetailComponent implements OnInit {
  errorMessage: string;
  tide: Tide;
  activeSection = 'summary';

  constructor(private tideService: TideService, private route: ActivatedRoute, private router: Router, private httpErrorHandler: HttpErrorHandler) {}

  ngOnInit() {
    this.getTide();
  }

  getTide() {
    this.route.params.forEach((params: Params) => {
      const id = +params['id'];
      this.tideService.getTide(id).subscribe(
        (tide) => {
          const handler = new Tide();
          this.tide = handler.apiMap(tide);
        },
        (error) => this.httpErrorHandler.handleHttpError(error)
      );
    });
  }

  switchSection(section) {
    this.activeSection = section;
  }

  updateTideIncidencesStatus(tide, status) {
    tide.update_requested = status;
  }
}



// WEBPACK FOOTER //
// ./src/app/tides/tide-detail/tide-detail.component.ts